module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nevada-map', {
    attrs: {
      "mapFile": "nv.counties.json",
      "dataFile": "nv_load.csv",
      "res": "Lake Mead",
      "resFile": "nv.json",
      "whichState": "NV"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "NV"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "nv.counties.json",
      "centersFile": "nv_centers.json",
      "dataFile": "nv-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72071c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nevada.vue
// module id = 378
// module chunks = 1